import {
  GET_FABRIC_TRADING_RESOURCE_SUCCESS,
  GET_FABRIC_TRADING_RESOURCE_ERROR,
  GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS,
  GET_FABRIC_TRADING_LIST_RESOURCE_ERROR,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: {},
  dataForList: [],
  error: {},
  errorForList: {},
  status: statuslist.idle,
}

const FabricTradingCompanyResource = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_FABRIC_TRADING_RESOURCE_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_FABRIC_TRADING_RESOURCE_ERROR:
      return {
        ...state,
        data: {},
        error: action.payload?.data,
        status: statuslist.error,
      }
    case GET_FABRIC_TRADING_LIST_RESOURCE_SUCCESS:
      return {
        ...state,
        dataForList: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_FABRIC_TRADING_LIST_RESOURCE_ERROR:
      return {
        ...state,
        dataForList: [],
        errorForList: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default FabricTradingCompanyResource
